import SuperAdminHome from '@/layouts/SuperAdminHome.vue'

const type = 'admin'

export const adminRoute = {
  path: '/admin',
  name: 'admin',
  component: SuperAdminHome,
  meta: {
    resource: [{ admin: 'all' }],
    type,
  },
  children: [
    {
      path: 'dashboard',
      name: `${type}/dashboard`,
      component: () => import(/* webpackChunkName: "SuperAdminDashboard" */ '../../views/SuperAdminDashboard.vue'),
    },
    {
      path: 'list-of-advisors/:advisorsParam?',
      name: `${type}/list-of-advisors`,
      component: () => import(/* webpackChunkName: "ListOfAdvisors" */ '../../views/ListOfAdvisors.vue'),
      children: [
        {
          path: 'all/:p?',
          name: `${type}/all-advisors`,
          component: () =>
            import(
              /* webpackChunkName: "ListAdvisorsAll" */ '../../components/SuperAdmin/ListOfAdvisors/ListAdvisorsAll.vue'
            ),
        },
      ],
    },
    {
      path: 'leads',
      name: `${type}/leads`,
      component: () => import(/* webpackChunkName: "Leads" */ '../../views/Leads.vue'),
      children: [
        {
          path: 'all-leads/:p?',
          name: `${type}/all-leads`,
          component: () => import(/* webpackChunkName: "ListLeads" */ '../../components/ListLeads/ListAllLeads.vue'),
        },
        {
          path: 'active-leads/:p?',
          name: `${type}/active-leads`,
          component: () =>
            import(/* webpackChunkName: "ListActiveLeads" */ '../../components/ListLeads/ListActiveLeads.vue'),
        },
        {
          path: 'deactivated-leads/:p?',
          name: `${type}/deactivated-leads`,
          component: () =>
            import(
              /* webpackChunkName: "ListDeactivatedLeads" */ '../../components/ListLeads/ListDeactivatedLeads.vue'
            ),
        },
      ],
    },
    {
      path: 'list-of-households/:AdminHouseholdsParam?',
      name: `${type}/list-of-households`,
      component: () => import(/* webpackChunkName: "ListOfHouseholds" */ '../../views/ListOfHouseholds.vue'),
      children: [
        {
          path: 'all/:p?',
          name: `${type}/all`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListAll.vue'),
        },
         {
          path: 'opportunities/:p?',
          name: `${type}/opportunities`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListOpportunities.vue'
            ),
        },
        {
          path: 'prospects/:p?',
          name: `${type}/prospects`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProspects.vue'
            ),
        },
        {
          path: 'clients/:p?',
          name: `${type}/clients`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListClients.vue'),
        },
        {
          path: 'business/:p?',
          name: `${type}/business`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListBusiness.vue'),
        },
        {
          path: 'professional-relationship/:p?',
          name: `${type}/professional-relationship`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProfessionalRelationship.vue'
            ),
        },
      ],
    },
    {
      path: 'schwab/:p?',
      name: `schwab`,
      component: () =>
        import(/* webpackChunkName: "ListContent" */ '../../components/SchwabReport/SchwabDashboard.vue'),
    },
    {
      path: 'profile/:id?/:p?',
      name: `${type}/profile`,
      component: () =>
        import(/* webpackChunkName: "Transactions" */ '../../components/SchwabReport/Account/Profile.vue'),
    },
    {
      path: 'annuity-index',
      name: 'annuity-index',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
    },
    {
      path: 'annuity-index-details/:id?',
      name: 'annuity-index-details',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
    },

    {
      path: 'activity',
      name: `${type}/activity`,
      component: () => import(/* webpackChunkName: "Activity" */ '../../views/Activity.vue'),
    },
    {
      path: 'pipeline/:p?',
      name: `${type}/pipeline`,
      component: () => import(/* webpackChunkName: "PipeLine" */ '../../views/PipeLine.vue'),
    },
    {
      path: 'member/:id',
      name: `${type}/member`,
      component: () => import(/* webpackChunkName: "MemberDetails" */ '../../views/MemberDetails.vue'),
      children: [
        {
          path: 'member-details',
          name: `${type}/member-details`,
          component: () =>
            import(/* webpackChunkName: "MemberDetails" */ '../../components/MemberDetails/MemberDetails.vue'),
        },
        {
          path: 'annuity-index/:annuityId',
          name: `${type}/annuity-index`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
        },

        {
          path: 'annuity-index-details/:annuityId?',
          name: `${type}/annuity-index-details`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
        },
        {
          path: 'tasks',
          name: `${type}/tasks`,
          component: () =>
            import(/* webpackChunkName: "MemberDetails" */ '../../components/Tasks/MemberAllTaskList.vue'),
        },
      ],
    },
    {
      path: 'blueprint-report/:id',
      name: `${type}/blueprint-report`,
      component: () => import(/* webpackChunkName: "BlueprintReport" */ '../../components/Report/BlueprintReport.vue'),
    },
    {
      path: 'client-report/:id',
      name: `${type}/clientreport`,
      component: () => import(/* webpackChunkName: "ClientReport" */ '../../views/ClientReport.vue'),
      children: [
        {
          path: 'client-reports-list',
          name: `${type}/client-reports-list`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ClientReportList.vue'),
        },
        {
          path: 'contract-info/:contract_id?',
          name: `${type}/contract-info`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ContractDetails.vue'),
        },
      ],
    },
    {
      path: 'export-report/:id',
      name: `${type}/export-report`,
      component: () =>
        import(
          /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ExportClientReports.vue'
        ),
      children: [
        {
          path: 'all',
          name: `${type}/all-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportAll.vue'
            ),
        },
        {
          path: 'pdf',
          name: `${type}/pdf-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportPdf.vue'
            ),
        },
        {
          path: 'excel',
          name: `${type}/excel-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportExcel.vue'
            ),
        },
      ],
    },
    {
      path: 'past-stress-test/:id',
      name: `${type}/past-stress-test`,
      component: () =>
        import(
          /* webpackChunkName: "PastStressTestResults" */ '../../components/MemberDetails/PastStressTestResults.vue'
        ),
    },
    {
      path: 'opportunity-contact/:id',
      name: `${type}/opportunity-contact`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityContact" */ '../../components/OpportunityContact/OpportunityContact.vue'
        ),
    },
    {
      path: 'basic-information/:id',
      name: `${type}/basic-information`,
      component: () =>
        import(
          /* webpackChunkName: "MemberDetails" */ '../../components/MemberBasicInformation/MemberBasicInformation.vue'
        ),
    },
    {
      path: 'asset-accounts/:id',
      name: `${type}/asset-accounts`,
      component: () =>
        import(/* webpackChunkName: "AssetAccounts" */ '../../components/AssetAccounts/AssetAccounts.vue'),
    },

    {
      path: 'assets-consolidations/:id',
      name: `${type}/assets-consolidations`,
      component: () =>
        import(
          /* webpackChunkName: "AssetsConsolidations" */ '../../components/AssetsConsolidations/AssetsConsolidations.vue'
        ),
    },
    {
      path: 'revenue-dashboard',
      name: `${type}/revenue-dashboard`,
      component: () => import(/* webpackChunkName: "RevenueDashboard" */ '../../components/RevenueDashboard/RevenueDashboard.vue'),
    },
    {
      path: 'analytics-dashboard',
      name: `${type}/analytics-dashboard`,
      component: () => import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/RevenueDashboard/AnalyticsDashboard.vue'),
    },
    {
      path: 'meeting-note-print/:id',
      name: `${type}/meeting-note-print`,
      component: () =>
        import(/* webpackChunkName: "MeetingNotePrintPreview" */ '../../components/MeetingNotes/MeetingNotePrintPreview.vue'),
    },
    {
      path: 'task/new',
      name: `${type}/task-new`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'task/:taskId',
      name: `${type}/task-edit`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'interaction/new',
      name: `${type}/interaction-new`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
    },
    {
      path: 'interaction/:interactionId',
      name: `${type}/interaction-edit`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
    },
  ],
}
